// extracted by mini-css-extract-plugin
export default {"feedbackContainer":"Feedback_feedbackContainer__0uf1r","feedbackItem":"Feedback_feedbackItem__YnhFh"};